module.exports = __webpack_public_path__ + "img/3dots.84ca0f87.svg";